"use client"

import { createContext, useContext, useEffect, useState } from "react"

const Context = createContext<{ dotFieldIndex: string; setDotFieldIndex: (index: string) => void }>(
  {
    dotFieldIndex: "",
    setDotFieldIndex: () => {
      /* empty */
    }
  }
)

// App context. Allows the dot field animation state to be set dynamically,
// which is done with scroll trigger events on the homepage, or a default
// low contrast animation field for non-homepages.
export function ContextProvider({ children }: { children: React.ReactNode }) {
  const [dotFieldIndex, setDotFieldIndex] = useState("")
  return <Context.Provider value={{ dotFieldIndex, setDotFieldIndex }}>{children}</Context.Provider>
}

export function useOurContext() {
  return useContext(Context)
}

export function SetDotFieldIndex({ index }: { index: string }) {
  const { setDotFieldIndex } = useOurContext()

  useEffect(() => {
    setDotFieldIndex(index)
  }, [setDotFieldIndex, index])

  return <></>
}
